import { createStyles } from 'antd-style';

import { ThemeColors } from '../theme';
import { heightExtendingError } from '../styles/mixins';

export const useNewQuotePageStyles = createStyles(({ token }) => ({
  quotePageBase: {
    '&&': {
      ...heightExtendingError(token),
    },
  },
  editQuoteLabel: {
    color: ThemeColors.COLOR_GREY11,
    fontFamily: token.fontFamily,
    fontWeight: 500,
  },
  editQuoteId: {
    color: token.colorPrimary,
    fontFamily: token.fontFamily,
    fontWeight: 500,
  },
  quoteSubmitButton: {
    '> .ant-btn-primary[disabled]': {
      '&, &:hover, &:active': {
        backgroundColor: token.colorPrimary,
        opacity: 0.65,
      },
    },

    '.ant-btn-primary': {
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        fontSize: token.fontSizeSM,
        padding: 0,
        height: 24,
        width: 85,
      },
    },
  },
}));
